<template>

    <section  class="firm-sec" v-if="$store.state.settings.site_id == 1">
            <div class="container">
        <router-link to="{name:'stores'}" class="firm-sec__banner">
            <picture>
                <source srcset="https://batnorton.com/img/about4.webp" type="image/webp">
                <img src="https://batnorton.com/img/about4.jpg" class="firm-sec__banner-img" :alt="trans('BRANDED STORES')"></picture>
        </router-link>
        <div class="sec-title-container">
            <p class="sec-title-container__dop-text"> Bat Norton </p>
            <h4 class="sec-title"> {{ trans('BRANDED STORES') }} </h4>
        </div>
    </div>

    </section>
</template>

<script>
export default {
    name: "firm-sec"
}
</script>

<style scoped>
.sec-title{
    text-align: center;
}
</style>
